var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00378 13.4021C11.0081 13.4021 14.2917 8.45627 14.2917 4.1674C14.2917 4.02694 14.2888 3.88712 14.2824 3.74789C14.9214 3.28823 15.4728 2.71911 15.9108 2.06719C15.3259 2.32574 14.6965 2.49976 14.0362 2.57821C14.7101 2.17641 15.2275 1.54074 15.4716 0.783034C14.8308 1.16099 14.1298 1.42742 13.3988 1.57086C12.8031 0.939982 11.955 0.54541 11.016 0.54541C9.21328 0.54541 7.75143 1.99892 7.75143 3.7906C7.75143 4.04532 7.78011 4.29301 7.83612 4.53067C5.12304 4.39493 2.71728 3.10341 1.10722 1.13958C0.817235 1.6349 0.664706 2.19784 0.665213 2.7709C0.665213 3.89696 1.24149 4.89101 2.11788 5.47258C1.59949 5.45684 1.09247 5.31762 0.639471 5.06663C0.638986 5.08026 0.638986 5.09353 0.638986 5.10809C0.638986 6.67992 1.76419 7.9923 3.25786 8.28967C2.97733 8.36564 2.68785 8.40404 2.39709 8.40387C2.18712 8.40387 1.98248 8.38334 1.78359 8.34538C2.19918 9.63497 3.40426 10.5734 4.83303 10.5996C3.71575 11.4703 2.30832 11.9889 0.778658 11.9889C0.518442 11.9892 0.258439 11.9741 0 11.944C1.44471 12.8647 3.16 13.4021 5.00378 13.4021Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.80f49b771dd3fe6f7f638394a2120e5a.svg";
export { ForwardRef as ReactComponent };